export const FLAG_GETTING_UNRETURNED_AMOUNT = 'FLAG_GETTING_UNRETURNED_AMOUNT';
export const GET_UNRETURNED_AMOUNT = 'GET_UNRETURNED_AMOUNT';
export const CLEAR_UNRETURNED_AMOUNT = 'CLEAR_UNRETURNED_AMOUNT';